if (!window.Eurus.loadedScript.has('mobile-dock.js')) {
  window.Eurus.loadedScript.add('mobile-dock.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store('xMobileDock', {
        showDock: false,
        initMobileDock() {
          setTimeout(() => {
            const stickyAtc = document.querySelector('.sticky_add_to_cart');
            let heightMobileDock;
            if (stickyAtc) {
              const containerMobileDock = document.getElementById("mobile-dock-container");
              heightMobileDock = containerMobileDock ? containerMobileDock.offsetHeight : 0;
            }
            
            requestAnimationFrame(() => {
              if (stickyAtc) {
                const value = heightMobileDock + "px";
                stickyAtc.style.setProperty('--height-mobile-dock', value);
                document.body.style.marginBottom = value;
              }
            });
          }, 0);
          
          // --- SMART SCROLL UPGRADE ---
          let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          let isTicking = false;

          const updateDock = () => {
            let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            if (window.xViewport.innerWidth > 768) {
              this.showDock = false;
              isTicking = false;
              return;
            }

            const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight;

            // 1. Bypass iOS over-scroll boundaries completely
            if (currentScrollTop < 0 || currentScrollTop >= maxScrollTop) {
              isTicking = false;
              return;
            }

            // 2. Jitter Fix: If the difference is negligible (slowing to a halt), lock the state
            if (Math.abs(currentScrollTop - lastScrollTop) <= 2) {
              isTicking = false;
              return;
            }

            // 3. Instant Execution Logic
            if (currentScrollTop <= 50) {
              this.showDock = true;
            } else if (currentScrollTop > lastScrollTop) {
              // Scrolling down: Hide instantly
              this.showDock = false;
            } else {
              // Scrolling up: Show instantly
              this.showDock = true;
            }

            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
            isTicking = false;
          }

          // Optimized frame listener (No more debounce lag)
          window.addEventListener('scroll', () => {
            if (!isTicking) {
              window.requestAnimationFrame(updateDock);
              isTicking = true;
            }
          }, { passive: true });
          
          const dockContainer = document.getElementById("mobile-dock-container");
          if (dockContainer) {
            dockContainer.addEventListener('focusin', () => {
              this.showDock = true;
            });
          }
        },
        setPositionSearch() {
          const search = document.getElementById('FormSearchMobileDock');
          if (search) {
            const announcement = document.getElementById('x-announcement');
            let height;
            if (announcement) {
              let sticky = announcement?.dataset.isSticky == "true";
              height = sticky ? announcement?.offsetHeight : 0;  
            } else {
              height = 0;
            }
            search.style.setProperty('--announcement-height', `${height}px`);
          }
        }
      });
    });
  });
}